import defaultFlow from './flows/default_flow.json';
import partnerFlow from './flows/partner.json';
import { subflows } from './flows/subflows';

const PARTNER_FLOW = { ...partnerFlow.flow, name: partnerFlow.name, subflows };
const MERGED_FLOW = { ...defaultFlow.flow, name: defaultFlow.name, subflows };
const DEFAULT_REQUIRE_PHONE_FLOW = {
  ...defaultFlow.flow,
  name: 'default_require_phone',
  subflows,
};

export const getFlow = (flowName: string) => {
  if (flowName === 'default_require_phone') {
    return DEFAULT_REQUIRE_PHONE_FLOW;
  }

  if (flowName === 'partner' || flowName === 'opcity') {
    return PARTNER_FLOW;
  }

  return MERGED_FLOW;
};
